declare namespace $ {

	type $mol_view__sub_bog_fragile_demo_spread_base1_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_fragile_demo_spread_base1 extends $mol_view {
		Body( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=base1.view.tree.d.ts.map